import { EInternalNoteType } from '@constants';
import { Flex, Popover } from 'antd';
import { useTranslation } from 'react-i18next';

import { EmptyTypeWrapper } from './InternalNoteTypeSelector.styles';

import { Icon } from '@/components/Icon';
import { InternalNoteTypeTag } from '@/components/InternalNotes';

type Props = {
  value?: EInternalNoteType;
  onChange?: (value: EInternalNoteType) => void;
};

export const InternalNoteTypeSelector: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const content = (
    <Flex vertical gap={12}>
      {Object.values(EInternalNoteType).map(type => (
        <InternalNoteTypeTag key={type} type={type} onClick={() => onChange?.(type)} />
      ))}
    </Flex>
  );

  return (
    <Popover trigger="click" content={content} placement="bottomLeft" arrow={false}>
      {value ? (
        <InternalNoteTypeTag type={value} icon="ChevronDown" />
      ) : (
        <EmptyTypeWrapper>
          <Icon i="Add" />
          <div>{t('ADD_INTERNAL_NOTE_TYPE')}</div>
        </EmptyTypeWrapper>
      )}
    </Popover>
  );
};
